import { makeStyles } from 'tss-react/mui';
import { theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the input component.
 */
const useInputStyles = makeStyles()(() => ({
  inputTitle: {
    marginBottom: '8px',
    fontWeight: 'bold',
    fontFamily: theme.fontFamily,
  },
  inputHint: {
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize.smaller,
    color: theme.text.primary.light,
    marginBottom: theme.margin.xs,
    fontStyle: 'italic',
    marginLeft: theme.margin.s,
  },
  inputInput: {
    fontFamily: theme.fontFamily,
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.padding.s,
    borderRadius: theme.borderRadius.xs,
    maxWidth: 'none',
  },
}));

export default useInputStyles;
